import { render, staticRenderFns } from "./MobileGoToRegistration.vue?vue&type=template&id=030cd18e&scoped=true"
import script from "./MobileGoToRegistration.vue?vue&type=script&lang=js"
export * from "./MobileGoToRegistration.vue?vue&type=script&lang=js"
import style0 from "./MobileGoToRegistration.vue?vue&type=style&index=0&id=030cd18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030cd18e",
  null
  
)

export default component.exports